import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Download, CheckCircle2, PencilLine } from "lucide-react";

function RespondBox({ token, onDone }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const send = async (approved) => {
    if (!approved && !note.trim()) { setMsg("Tulis catatan revisi dulu."); return; }
    setBusy(true); setMsg("");
    try { await api.post(`/public/design-approval/${token}/respond`, { approved, note }); onDone(); }
    catch (e) { setMsg(e?.response?.data?.detail || "Gagal mengirim"); }
    setBusy(false);
  };
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 mt-6" data-testid="approval-respond-box">
      <div className="font-semibold">Jawaban Anda</div>
      <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={3} placeholder="Catatan (wajib bila minta revisi)" className="w-full mt-2 border border-slate-200 rounded-lg p-3 text-sm" data-testid="approval-note-input" />
      {msg && <p className="text-sm text-red-600 mt-1" data-testid="approval-respond-error">{msg}</p>}
      <div className="flex flex-wrap gap-3 mt-3">
        <button disabled={busy} onClick={() => send(true)} className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700 disabled:opacity-50" data-testid="approval-acc-btn"><CheckCircle2 className="w-4 h-4" /> ACC Design</button>
        <button disabled={busy} onClick={() => send(false)} className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-amber-500 text-amber-700 text-sm font-semibold hover:bg-amber-50 disabled:opacity-50" data-testid="approval-revisi-btn"><PencilLine className="w-4 h-4" /> Minta Revisi</button>
      </div>
    </div>
  );
}

export default function ApprovalView() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const load = () => { api.get(`/public/design-approval/${token}`).then(({ data }) => setD(data)).catch(() => setErr("Link tidak ditemukan")); };
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  const url = (i) => `${process.env.REACT_APP_BACKEND_URL}/api/public/design-approval/${token}/file/${i}`;
  if (err) return <div className="p-10 text-center text-slate-500">{err}</div>;
  if (!d) return <div className="p-10 text-center text-slate-400">Memuat...</div>;
  return (
    <div className="min-h-screen bg-slate-50 p-6 sm:p-10" data-testid="approval-view">
      <div className="max-w-4xl mx-auto">
        <div className="text-xs font-mono text-slate-500">FOMU 3D PRINT · {d.wo_code}</div>
        <h1 className="font-head text-3xl font-bold mt-1">{d.product}</h1>
        <p className="text-slate-600 mt-1">{d.round_label} untuk {d.customer_name}. Silakan cek file di bawah, lalu klik ACC atau Minta Revisi.</p>
        {d.note && <p className="text-sm text-slate-500 mt-2">{d.note}</p>}
        <div className="grid sm:grid-cols-2 gap-4 mt-6">
          {d.files.map((f) => (
            <div key={f.i} className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-testid={`approval-file-${f.i}`}>
              {String(f.content_type).startsWith("image/") ? <img src={url(f.i)} alt={f.filename} className="w-full object-contain max-h-96 bg-slate-100" /> : <div className="h-40 flex items-center justify-center text-slate-400 text-sm">File 3D / dokumen</div>}
              <a href={url(f.i)} target="_blank" rel="noreferrer" className="flex items-center gap-2 px-4 py-3 text-sm hover:bg-slate-50"><Download className="w-4 h-4" /> {f.filename}</a>
            </div>
          ))}
          {!d.files.length && <p className="text-sm text-slate-400">Belum ada file terlampir.</p>}
        </div>
        {d.status === "DONE" ? (
          <div className="mt-6 bg-white border border-slate-200 rounded-xl p-5 text-sm" data-testid="approval-done">
            {d.result === "ACC" ? "Terima kasih, design sudah di-ACC. Kami lanjutkan ke produksi." : d.result === "REVISI" ? "Permintaan revisi sudah kami terima. Tim design akan mengirim hasil revisi." : "Approval ini sudah tidak aktif."}
            {d.customer_note && <p className="text-slate-500 mt-1">Catatan: {d.customer_note}</p>}
          </div>
        ) : <RespondBox token={token} onDone={load} />}
      </div>
    </div>
  );
}
